import { jsPDF } from 'jspdf';

// Order sticker for a Brother QL-700 with 62mm continuous tape (DK-22205).
// The 62mm width is fixed by the tape; the height is the cut length we choose
// for the content. Three lines: customer name, order number, paid/unpaid.
const LABEL_WIDTH_MM = 62;
const LABEL_HEIGHT_MM = 30;
const MARGIN_MM = 3;

// Shrink the font until the text fits within maxWidth (so a long customer name
// can't overflow the 62mm tape), with a lower bound so it stays legible.
function fitFontSize(doc, text, maxWidthMm, startSize, minSize) {
    let size = startSize;
    doc.setFontSize(size);
    while (size > minSize && doc.getTextWidth(text) > maxWidthMm) {
        size -= 0.5;
        doc.setFontSize(size);
    }
    return size;
}

export function printOrderSticker(order) {
    if (!order) return;

    const customerName = (order.deliveryName || order.billingName || 'Client necunoscut').trim();
    const orderNumber = order.orderNumber != null ? order.orderNumber : order.id;
    const isPaid = order.paymentStatus === 'paid';
    const paymentLabel = isPaid ? 'PLATIT' : 'NEPLATIT';

    // Landscape so the 62mm edge is the WIDTH (jsPDF sorts the format array by
    // orientation: portrait would make 62 the height, which is wrong here).
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: [LABEL_WIDTH_MM, LABEL_HEIGHT_MM] });
    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = pageWidth / 2;
    const maxTextWidth = pageWidth - MARGIN_MM * 2;

    // Typewriter look: Courier (jsPDF built-in monospace), bold throughout.
    // Customer name
    doc.setFont('courier', 'bold');
    fitFontSize(doc, customerName, maxTextWidth, 14, 7);
    doc.text(customerName, centerX, 9, { align: 'center', maxWidth: maxTextWidth });

    // Order number
    doc.setFont('courier', 'bold');
    const orderLine = `Comanda #${orderNumber}`;
    fitFontSize(doc, orderLine, maxTextWidth, 12, 7);
    doc.text(orderLine, centerX, 17, { align: 'center', maxWidth: maxTextWidth });

    // Payment status. Unpaid is drawn inverted (white on black) so it's
    // impossible to miss when the sticker is on the parcel.
    doc.setFont('courier', 'bold');
    doc.setFontSize(15);
    if (isPaid) {
        doc.setTextColor(0, 0, 0);
        doc.text(paymentLabel, centerX, 26, { align: 'center' });
    } else {
        const boxW = 40;
        const boxH = 9;
        const boxX = centerX - boxW / 2;
        const boxY = 20;
        doc.setFillColor(0, 0, 0);
        doc.rect(boxX, boxY, boxW, boxH, 'F');
        doc.setTextColor(255, 255, 255);
        doc.text(paymentLabel, centerX, boxY + 6.2, { align: 'center' });
        doc.setTextColor(0, 0, 0);
    }

    // Open the PDF and trigger the print dialog (QL-700) automatically.
    doc.autoPrint();
    window.open(doc.output('bloburl'), '_blank');
}
